import Constants from '~/components/Constants';
import LoadingArea from '~/components/LoadingArea';
import ToastsContainer from '~/containers/Toasts';
import { createResponse } from '~/lib/client';
import { useFancyQuery } from '~/lib/graphql';

import query from './query.graphql';
import styles from './styles';
import UpgradeAccountComplete from './UpgradeAccountComplete';
import UpgradeAccountForm from './UpgradeAccountForm';
import useForm from './useForm';

function UpgradeAccount({
  classes,
  name,
  email,
  onSubmit,
  submitted,
  product,
  ...props
}) {
  let initialValues = { name, email };

  if (product) {
    initialValues[product] = true;
  }

  const { values, onChange, valid } = useForm({
    initialValues,
  });

  const handleSubmit = (event) => {
    event.preventDefault();

    onSubmit(values);
  };

  return (
    <>
      <div className={classes.header}>
        <h1 className={classes.title}>Upgrade your Clearbit X plan</h1>
        <span>
          Contact our success team to add additional Clearbit plans to your
          account
        </span>
      </div>
      {submitted ? (
        <UpgradeAccountComplete email={values.email} {...props} />
      ) : (
        <UpgradeAccountForm
          values={values}
          valid={valid}
          onChange={onChange}
          onSubmit={handleSubmit}
          {...props}
        />
      )}
    </>
  );
}

const ConnectedUpgradeAccount = (props) => {
  const [loading, setLoading] = useState(true);
  const [submitted, setSubmitted] = useState(false);
  const [user, setUser] = useState({});

  const handleSubmit = async (values) => {
    const form_id = Constants.CONTACT_SUCCESS_FORM_ID;

    const {
      email,
      name,
      message,
      alerting,
      advertising,
      personalization,
    } = values;

    const products = { alerting, advertising, personalization };
    const product = Object.keys(products)
      .filter((key) => products[key])
      .join(', ');

    const attributes = {
      form_id,
      values: {
        email,
        name,
        message,
        product,
      },
    };

    setLoading(true);

    try {
      await createResponse(attributes);

      setSubmitted(true);
    } catch (e) {
      ToastsContainer.addError('There was an error submitting the form.');
    }

    setLoading(false);
  };

  const { data, loading: loadingGraphQL, error } = useFancyQuery(query);

  useEffect(() => {
    if (!loadingGraphQL || error) {
      setUser(data.viewer.user);
      setLoading(false);
    }
  }, [data, error, loadingGraphQL]);

  useEffect(() => {
    if (error) {
      ToastsContainer.addError('There was an error loading the form.');
    }
  }, [error]);

  if (loading) {
    return (
      <div className={props.classes.root}>
        <LoadingArea loading />
      </div>
    );
  }

  return (
    <div className={props.classes.root}>
      <UpgradeAccount
        error={error}
        name={user.name}
        email={user.email}
        onSubmit={handleSubmit}
        submitted={submitted}
        {...props}
      />
    </div>
  );
};

ConnectedUpgradeAccount.propTypes = {
  classes: PropTypes.object.isRequired,
  backPath: PropTypes.string,
  product: PropTypes.string,
};

export default withStyles(styles)(ConnectedUpgradeAccount);
